import {
  ChatBubble as ChatBubbleIcon,
  EventNote as EventNoteIcon,
  Hotel as HotelIcon,
  LockOpen as LockOpenIcon
} from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Profile, SidebarNav } from './components';
import { Divider, Drawer } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: { margin: theme.spacing(2, 0) },
  nav: { marginBottom: theme.spacing(2) }
}));

const SideBarAppCli = props => {
  const {
    className,
    onClose,
    open,
    variant,
    ...rest
  } = props;

  const classes = useStyles();

  const pages = [
    {
      title: 'Programação',
      href: '/appcli/programacao',
      icon: <EventNoteIcon />
    },
    {
      title: 'Hospedagem',
      href: '/appcli/hospedagem',
      icon: <HotelIcon />
    },
    {
      title: 'Fale Conosco',
      href: '/appcli/faleconosco',
      icon: <ChatBubbleIcon />
    },
    {
      title: 'Sair',
      href: '/logout',
      icon: <LockOpenIcon />
    }
  ];

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div
        {...rest}
        className={clsx(
          classes.root,
          className
        )}
      >
        <Profile />

        <Divider
          className={classes.divider}
        />

        <SidebarNav
          className={classes.nav}
          pages={pages}
        />
      </div>
    </Drawer>
  );
};

SideBarAppCli.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default SideBarAppCli;